import PropTypes from 'prop-types';

export const modelAfterPropTypes = {
	appId: PropTypes.number.isRequired,
	changeHandler: PropTypes.func,
	name: PropTypes.string,
};
